import React from "react";
import ImgDestaque from "../../../../assets/images/foto-destaque-gradua-noiz.jpg";
import ImgGraduaNoiz1 from "../../../../assets/images/foto-galeria-gradua-noiz-1.jpg";
import ImgGraduaNoiz2 from "../../../../assets/images/foto-galeria-gradua-noiz-2.jpg";
import ImgGraduaNoiz3 from "../../../../assets/images/foto-galeria-gradua-noiz-3.jpg";
import Galery from "../../../../components/Galery";

const galeryImgs = [
  { src: ImgGraduaNoiz1, alt: "Gradua Nóiz 1" },
  { src: ImgGraduaNoiz2, alt: "Gradua Nóiz 2" },
  { src: ImgGraduaNoiz3, alt: "Gradua Nóiz 3" },
];

const GraduaNoiz = () => {
  return (
    <div className="detalhes-iniciativa">
      <main className="banner-detalhes-iniciativa-mobile bg-gradua-noiz" />

      <section className="detalhes-iniciativa-content container">
        <div className="row gutters">
          <div className="col grid_6">
            <h2 className="subtitulo-verde">GRADUA NÓIZ</h2>
            <p>
              Um pré-vestibular social com professores voluntários, para
              oferecer um boa estrutura de estudo a quem não pode pagar um
              cursinho.
            </p>
          </div>
          <div className="col grid_6">
            <img src={ImgDestaque} alt="Gradua Nóiz" />
          </div>
        </div>
      </section>

      <Galery galeryImgs={galeryImgs} />
    </div>
  );
};

export default GraduaNoiz;
